import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { writeBehaviorAllOptions, writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { maxConcurrentConnectionsMetadata } from '../consts/metadata-consts';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { getMergeOption, getReplaceOption } from 'app/registries/consts/copy-job-const';
import { UpdateMethod } from 'shell-models-lib';

const azureSearchSinkWriteBehaviors = [writeBehaviorOptionValues.merge, writeBehaviorOptionValues.upload];
export const azureSearchIndexMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.azureSearch.datasetType,
    displayName: stringResources.AzureSearch_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.azureSearch.linkedServiceType],
    notSupportLookupActivity: true,
    isSource: false,
    isSink: true,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-SearchIndex'
    },
    tableNameDisplay: stringResources.TableNameDisplay_IndexName,
    tableNamePlural: stringResources.Indexes,
    isTableRequired: true,
    isFirstClass: true,
    category: ['Azure'],
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    copySinkControls: [
        {
            type: 'parameterizable-dropdown',
            bind: 'writeBehavior',
            label: __IS_FABRIC_DPE__ ? stringResources.ModelName_IndexAction : stringResources.ModelName_WriteBehavior,
            isLabelVertical: false,
            options: writeBehaviorAllOptions
                .filter((option) => azureSearchSinkWriteBehaviors.indexOf(option.value) >= 0)
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'writeBatchSize',
                label: stringResources.ModelName_WriteBatchSize,
                inputType: 'number',
                defaultValue: 1000,
                min: 0,
                max: 1000
            },
            dynamicContentTextClass: 'input-spaced'
        },
        maxConcurrentConnectionsMetadata
    ],
    copyJob: {
        updateMethod: {
            supportUpdateMethod: true,
            options: [getMergeOption(), getReplaceOption()],
            updateMethodProperties: ['indexAction'],
            defaultUpdateMethod: UpdateMethod.Upsert,
            noUpsertKeyColumn: true
        }
    }
};
